import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { DocumentManagementClient } from './document-management-client.js';

export function useDocumentManagementClient(): DocumentManagementClient {
  const httpClient = useHttpClient({ type: 'editor' });
  return useMemo(() => new DocumentManagementClient(httpClient), [httpClient]);
}
